import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { SystemProvider } from '../../features/system/provider'
import { Labels } from './list-filter-labels'
import PropTypes from 'prop-types'
import { setQueryString } from '../../features/search/slice'
import { setSelectedAudienceId } from '../../features/system/slice'
import { QUERY_BLACKLIST as BLACKLIST } from '../../constants'
import { useInternationalization } from '../../features/i18n'

const IDLE = 'idle'

const Filters = ({query, setStatus}) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const { translate } = useInternationalization()
  const filteredKeys = Object.keys(query).filter(key => BLACKLIST.includes(key) === false)
  const renderable = query && filteredKeys.length > 0

  const handleClear = () => {
    console.log(setStatus)

    if(setStatus){
      dispatch(setStatus(IDLE))
    }

    dispatch(setQueryString(''))
    dispatch(setSelectedAudienceId(1))

    history.push(location.pathname)
  }

  return <>
    {
      renderable &&
      <div className="flex items-center mb-5 lg:mb-8">
        <div className="w-3/5 lg:w-auto filter-items-wrapper order-2 lg:order-1 overflow-x-auto">
          <SystemProvider>
            <Labels query={query}/>
          </SystemProvider>
        </div>
        <div
          className="w-2/5 lg:w-auto order-1 lg:order-2 lg:ml-4 cursor-pointer flex-none"
          onClick={() => handleClear()}
        >
          <p className="opacity-50 lg:opacity-100 text-gray-444 underline text-xs mb-2">
            {translate('SEARCH', 'clear')}
          </p>
        </div>
      </div>
    }
  </>
}

Filters.propTypes = {
  query: PropTypes.object,
}

Filters.defaultProps = {
  query: {},
}

export default Filters
